// SnpWebSocketEngine.js
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import { PayLoadType, ToneType, WS_PARENT_ID, WS_TOKEN } from '../utils/SnpChatConstant';


class SnpWebSocketEngine {
  constructor() {
    this.socket = null;
    this.parentId = null;
    this.token = null;
    this.url = null;
    this.as = PayLoadType.AS_CHAT;
    this.socketUrl = null;
    this.admin = false;
    this.pingTimeout = null;
    this.messageCallbacks = [];
    this.reconnectDelay = 1000;
    this.manualClose = false;
  }

  connect(parentId, token, url, as, socketUrl, handleCustomToastFunc = (tag, msg, isError, toneType = ToneType.No_Sound) => { }, onSocketOpenClose = (isOpen) => { }) {
    this.parentId = encodeURIComponent(parentId);
    this.token = encodeURIComponent(token);
    this.url = url;
    this.as = as;
    this.socketUrl = socketUrl;

    // Already connected, verify with ping
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this._pingCheck()
        .then((alive) => {
          if (!alive) this._forceReconnect();
        })
        .catch(() => this._forceReconnect());
      return;
    }

    this._initSocket(onSocketOpenClose);
  }

  _initSocket(onSocketOpenClose = (isOpen) => { }, handleCustomToastFunc = (tag, msg, isError, toneType = ToneType.No_Sound) => { }) {
    this.manualClose = false;
    const wsUrl = `${this.url}${this.socketUrl}?${WS_PARENT_ID}=${this.parentId}&${WS_TOKEN}=${this.token}&as=${this.as}`;
    this.socket = new W3CWebSocket(wsUrl);

    this.socket.onopen = () => {
      console.info('[SocketManager] Connected');
      onSocketOpenClose(true);
    };

    this.socket.onmessage = (event) => {
      if (event.data === 'pong') {
        clearTimeout(this.pingTimeout);
        return;
      }

      try {
        //const message = JSON.parse(event.data); Remove as I dont know the format of message
        this.messageCallbacks.forEach((cb) => cb(event.data));
      } catch (err) {
        console.error('[SocketManager] Message parse error', err);
      }
    };

    this.socket.onerror = (err) => {
      console.error('[SocketManager] Error', err);
    };

    this.socket.onclose = () => {
      console.warn('[SocketManager] Disconnected');
      this.socket = null;
      onSocketOpenClose(false);
      if (!this.manualClose) {
        setTimeout(() => this._initSocket(), this.reconnectDelay);
      }
    };
  }

  _pingCheck() {
    return new Promise((resolve, reject) => {
      if (!this.socket || this.socket.readyState !== WebSocket.OPEN) return reject();

      this.socket.send('ping');
      this.pingTimeout = setTimeout(() => reject('No pong'), 2000);

      const pongListener = (e) => {
        if (e.data === 'pong') {
          this.socket.removeEventListener('message', pongListener);
          clearTimeout(this.pingTimeout);
          resolve(true);
        }
      };

      this.socket.addEventListener('message', pongListener);
    });
  }

  _forceReconnect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
    this._initSocket();
  }

  registerCallback(cb) {
    if (!this.messageCallbacks.includes(cb)) {
      this.messageCallbacks.push(cb);
    }
  }

  unregisterCallback(cb) {
    this.messageCallbacks = this.messageCallbacks.filter((f) => f !== cb);
  }

  send(textMessage) {
    const sendMessage = () => {
      try {
        if (this.socket.readyState === WebSocket.OPEN) {
          this.socket.send(textMessage);
        } else {
          console.warn('[SocketManager] Socket not open, retrying...');
          this._forceReconnect();
          setTimeout(() => this.send(textMessage), 1000);
        }
      } catch (err) {
        console.error('[SocketManager] Send error', err);
        this._forceReconnect();
      }
    };

    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      this._initSocket();
      setTimeout(sendMessage, 1000);
    } else {
      sendMessage();
    }
  }

  close() {
    this.manualClose = true;
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  isConnected() {
    if (this.socket === null) {
      return false;
    }
    return this.socket.readyState === WebSocket.OPEN;
  }
}

const snpWebSocketEngineInstance = new SnpWebSocketEngine();
export default snpWebSocketEngineInstance;